export default __webpack_public_path__ + "static/media/vodkadrinks.e3d84fdf.png";